module.exports = __webpack_public_path__ + "static/media/47.d6099bb2.png";